// Copyright (c) 2023 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/additionalUi"
import { GRID_TAGS_VIEW_TYPE } from "../../../app/localStorageKeys"

export type StorageWriter = (value: Slice.TagsViewType) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(GRID_TAGS_VIEW_TYPE, value.toString())
}

export const persistTagsViewType = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setTagsViewType.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.tagsViewTypePersisted()),
        catchError(_ => of(Actions.tagsViewTypePersistFailed())),
      )),
    )

export default persistTagsViewType(persist)
